import classNames from 'classnames'
import React from 'react'
import Icon from '../icon'
import './index.less'

export default function (props) {
  const { className, style, data = [], value, size = 'large', counts = [], onChange } = props
  return <div className={classNames('meinian-tab-TD', className)} style={style}>
    {data?.map((item, index) => <TabTDCell
      onClick={e => onChange && onChange(item.value, e)}
      active={item.value === value}
      disabled={item.disabled}
      icon={item.icon}
      value={value}
      size={size}
      count={counts[index]}
      suffix={item.suffix}
    >
      {item.label}
    </TabTDCell>)}
  </div>
}

export const TabTDCell = (props) => {
  const { className, style, onClick, disabled, active, size = 'large', count, suffix, icon } = props
  return <div
    className={classNames('meinian-tab-TD-cell', className, size, { text: !icon, icon, active, disabled })}
    style={style}
    onClick={(e) => {
      if (disabled) { return }
      onClick && onClick(e)
    }}
  >
    {icon ? <Icon type={icon} /> : null}
    <span className="text">{props.children}</span>
    {(count) ? <span className="count">({count})</span> : null}
    {suffix}
  </div>
}
